import { render, staticRenderFns } from "./SidebarFilters.vue?vue&type=template&id=36bbae5f&scoped=true"
import script from "./SidebarFilters.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarFilters.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SidebarFilters.vue?vue&type=style&index=0&id=36bbae5f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bbae5f",
  null
  
)

export default component.exports